import React from "react";
import Modal from "./index";
import Button from "../Button";
import { useNavigate } from "react-router-dom";

export default function PreSolutionCheckModal({ show, showSolution,  }) {
    const navigate = useNavigate();
    return (
        <Modal show={show} onClose={showSolution}>
            <h1>🚨Spoiler Alert🚨</h1>
            <p style={{ textAlign: "left" }}>
                You haven’t played yet today! Viewing the solution now will spoil the challenge. Are you sure you want to continue?
            <br />
            </p>
            <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
                <Button onClick={()=>navigate("/")} text="I want to play!" />
                <Button onClick={showSolution} text="Yes, I'm sure" />
            </div>
        </Modal>
    );
}